import React, { useState } from 'react';
import './simpleDatePicker.scss';

const SimpleDatePicker = ({
                              label,
                              name,
                              value,
                              setFieldValue,
                              error,
                              required = false,
                              maxDate,
                              ...other
                          }) => {
    const [focused, setFocused] = useState(false);

    const formattedValue =
        value instanceof Date
            ? value.toISOString().split('T')[0]
            : typeof value === 'string'
                ? value
                : '';

    const formattedMaxDate =
        maxDate instanceof Date ? maxDate.toISOString().split('T')[0] : undefined;

    const isActive = focused || formattedValue;

    return (
        <div className={`mb-3 simpleDatePicker ${isActive ? 'active' : ''}`}>
            {label && (
                <label
                    htmlFor={name}
                    className={`form-label floating-label ${isActive ? 'active' : ''}`}
                >
                    {label}
                </label>
            )}
            <input
                type="date"
                id={name}
                name={name}
                className={`form-control ${error ? 'is-invalid' : ''} ${!isActive ? 'hide-date-text' : ''}`}
                value={formattedValue}
                onChange={(e) => {
                    const newDate = e.target.value ? new Date(e.target.value) : null;
                    setFieldValue(name, newDate);
                }}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                max={formattedMaxDate}
                required={required}
                {...other}
            />
            {error && <div className="invalid-feedback fst-italic">{error}</div>}
        </div>
    );
};

export default SimpleDatePicker;
